<template>
  <b-tooltip :label="label" type="is-dark">
    <b-button @click="$emit('click')" :type="`is-${variant || 'dark'}`" class="is-outlined">
      <font-awesome-icon :icon="icon || 'clone'"/>
      <slot/>
    </b-button>
  </b-tooltip>
</template>

<script>
export default {
  emit: ['click'],
  props: {
    label: String,
    variant: String,
    icon: [Array, String],
  }
}
</script>